import React, { useEffect, useState } from 'react';
import CuadroDatos from '../../UI/CuadroDatos.js';
import TablaDatos from '../../UI/TablaDatos.js';
// OrdenarListaFechaDesc not used after refactor
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from './CuadroHonorDivision.module.css';

const CuadroHonorDivision = (props) => {
  const pais = props.pais;
  const division = props.division;
  const categoria = props.categoria;
  const [campeones, setCampeones] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    // ordenarTorneos logic inlined below via fetchData callback

    if (pais && division) {
      let URL = 'paises/' + pais.id + '/divisiones/' + division.id + '/cuadro_honor';
      if (categoria) {
        URL += '?categoria=' + categoria.codigo;
      }
      fetchData(URL, setCampeones);
    } else {
      setCampeones([]);
    }
  }, [pais, division, categoria, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos
        titulo={'Cuadro de Honor'}
        mostrar={true}
        isCargando={isCargando}
        error={erroresGetLista}
      >
        <TablaDatos
          estilo={`${styles.tablaDatos}`}
          lista={campeones}
          textoVacia="No hay datos a mostrar"
        >
          <tbody>
            <tr className={`${styles.titulos}`} key="0">
              <td className={`${styles.nombre}`}></td>
              <td className={`${styles.cantidad}`}>Títulos</td>
            </tr>
            {campeones &&
              campeones.map((item) => (
                <tr className={`${styles.valores}`} key={item.id}>
                  <td className={`${styles.nombre}`}>{item.nombre}</td>
                  <td className={`${styles.cantidad}`}>{item.total}</td>
                </tr>
              ))}
          </tbody>
        </TablaDatos>
      </CuadroDatos>
    </div>
  );
};

export default CuadroHonorDivision;
